import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export type OnboardingPathType =
  | 'have_a_list'
  | 'build_with_alfred'
  | 'templates';

export type OnboardingAlfredTabType =
  | 'country'
  | 'region'
  | 'sector'
  | 'industry';

export const createOnboardingEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackOnboardingPathSelected = (
    source: PosthogTrackingSource,
    type: OnboardingPathType
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.ONBOARDING_PATH_SELECTED,
      properties: { source, type },
    });

  const trackOnboardingAlfredTabSelected = (
    source: PosthogTrackingSource,
    type: OnboardingAlfredTabType
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.ONBOARDING_ALFRED_TAB_SELECTED,
      properties: { source, type },
    });

  return {
    trackOnboardingPathSelected,
    trackOnboardingAlfredTabSelected,
  };
};
